import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Percent } from "lucide-react";
import { Eyebrow, Reveal } from "./motion";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { scrollToId } from "@/lib/scroll";
import { SELECT_SERVICE_EVENT } from "@/lib/constants";

const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");

const DATA = {
    kiloan: {
        rows: [
            { name: "Cuci Lipat Reguler", price: "Rp 6.500", ket: "Min. 3 kg", eta: "3 hari", opt: "Kiloan — Cuci Lipat Reguler" },
            { name: "Cuci Lipat One Day", price: "Rp 7.500", ket: "Min. 3 kg", eta: "1 hari", opt: "Kiloan — Cuci Lipat One Day" },
            { name: "Cuci Lipat Express", price: "Rp 12.500", ket: "Min. 2 kg", eta: "6 jam", opt: "Kiloan — Cuci Lipat Express" },
            { name: "Cuci Setrika Reguler", price: "Rp 8.500", ket: "Min. 3 kg", eta: "3 hari", opt: "Kiloan — Cuci Setrika Reguler" },
            { name: "Cuci Setrika One Day", price: "Rp 9.500", ket: "Min. 3 kg", eta: "1 hari", opt: "Kiloan — Cuci Setrika One Day" },
            { name: "Cuci Setrika Express", price: "Rp 16.500", ket: "Min. 2 kg", eta: "6 jam", opt: "Kiloan — Cuci Setrika Express" },
            { name: "Pakaian Anak Reguler (Sabun Khusus)", price: "Rp 10.500", ket: "Min. 2 kg", eta: "3 hari", opt: "Kiloan — Pakaian Anak (Sabun Khusus)" },
            { name: "Pakaian Anak One Day (Sabun Khusus)", price: "Rp 11.500", ket: "Min. 2 kg", eta: "1 hari", opt: "Kiloan — Pakaian Anak (Sabun Khusus)" },
            { name: "Pakaian Anak Express (Sabun Khusus)", price: "Rp 20.500", ket: "Min. 2 kg", eta: "6 jam", opt: "Kiloan — Pakaian Anak (Sabun Khusus)" },
            { name: "Setrika Saja Reguler", price: "Rp 5.500", ket: "Min. 2 kg", eta: "3 hari", opt: "Kiloan — Setrika Saja" },
            { name: "Setrika Saja One Day", price: "Rp 6.500", ket: "Min. 2 kg", eta: "1 hari", opt: "Kiloan — Setrika Saja" },
            { name: "Setrika Saja Express", price: "Rp 10.500", ket: "Min. 2 kg", eta: "6 jam", opt: "Kiloan — Setrika Saja" },
            { name: "Bed Cover / Sprei / Selimut", price: "Rp 12.500", ket: "Min. 1 kg", eta: "3 hari", opt: "Kiloan — Bed Cover / Sprei / Selimut" },
            { name: "Self Service 4 kg (Sabun Include) Drop-Off", price: "Rp 20.000", ket: "1 load", eta: "3 hari", opt: "Kiloan — Self Service Drop-Off" },
            { name: "Self Service 8 kg (Sabun Include) Drop-Off", price: "Rp 30.000", ket: "1 load", eta: "3 hari", opt: "Kiloan — Self Service Drop-Off" },
            { name: "Self Service 8 kg (Sabun Include) Di Tunggu", price: "Rp 22.000", ket: "1 load", eta: "2 jam · gratis 1 air mineral", opt: "Kiloan — Self Service Di Tunggu" },
        ],
        extras: [
            "Pelembut Molto/Downy — Rp 1.500",
            "Antiseptik Dettol — Rp 200/ml (20 ml/mesin)",
            "Treatment Noda — mulai Rp 5.000",
            "Hanger — Rp 2.000",
            "Plastik PP — Rp 1.500",
            "Plastik Kresek Sedang — Rp 1.500",
            "Plastik Kresek Jumbo — Rp 3.500",
        ],
    },
    satuan: {
        rows: [
            { name: "Kemeja (Lengan Panjang/Pendek/Batik)", price: "Rp 20.000", ket: "Per pcs", eta: "2 hari", opt: "Satuan — Kemeja / Batik" },
            { name: "Kaos (Lengan Panjang/Pendek)", price: "Rp 15.000", ket: "Per pcs", eta: "2 hari", opt: "Satuan — Kaos / Polo / Celana" },
            { name: "Polo", price: "Rp 15.000", ket: "Per pcs", eta: "2 hari", opt: "Satuan — Kaos / Polo / Celana" },
            { name: "Celana (Panjang/Pendek)", price: "Rp 15.000", ket: "Per pcs", eta: "2 hari", opt: "Satuan — Kaos / Polo / Celana" },
            { name: "Sweater", price: "Rp 20.000", ket: "Per pcs", eta: "2 hari", opt: "Satuan — Sweater / Jaket" },
            { name: "Jaket", price: "Rp 35.000", ket: "Per pcs", eta: "2 hari", opt: "Satuan — Sweater / Jaket" },
            { name: "Pakaian Syar'i (Gamis/Koko)", price: "Rp 20.000", ket: "Per pcs", eta: "2 hari", opt: "Satuan — Pakaian Syar'i (Gamis/Koko)" },
            { name: "Jas Stelan", price: "Rp 50.000", ket: "Per stel", eta: "3 hari", opt: "Satuan — Jas / PDH / PDL" },
            { name: "Jas Atasan", price: "Rp 35.000", ket: "Per pcs", eta: "3 hari", opt: "Satuan — Jas / PDH / PDL" },
            { name: "PDH/PDU/PDL/Safari Stelan", price: "Rp 35.000", ket: "Per stel", eta: "3 hari", opt: "Satuan — Jas / PDH / PDL" },
            { name: "PDH/PDU/PDL/Safari Atasan", price: "Rp 25.000", ket: "Per pcs", eta: "3 hari", opt: "Satuan — Jas / PDH / PDL" },
            { name: "Kebaya / Long Dress Sederhana", price: "Rp 35.000", ket: "Per pcs", eta: "3 hari", opt: "Satuan — Kebaya / Long Dress" },
            { name: "Kebaya / Long Dress Payet", price: "Rp 50.000", ket: "Per pcs", eta: "3 hari", opt: "Satuan — Kebaya / Long Dress" },
            { name: "Boneka Kecil", price: "Rp 20.000", ket: "Per pcs", eta: "5 hari", opt: "Satuan — Boneka / Bantal / Gorden / Karpet" },
            { name: "Boneka Sedang", price: "Rp 40.000", ket: "Per pcs", eta: "5 hari", opt: "Satuan — Boneka / Bantal / Gorden / Karpet" },
            { name: "Boneka Besar", price: "Rp 70.000", ket: "Per pcs", eta: "5 hari", opt: "Satuan — Boneka / Bantal / Gorden / Karpet" },
            { name: "Bantal / Guling", price: "Rp 20.000", ket: "Per pcs", eta: "5 hari", opt: "Satuan — Boneka / Bantal / Gorden / Karpet" },
            { name: "Gorden", price: "Rp 15.000", ket: "Per 2 kg", eta: "5 hari", opt: "Satuan — Boneka / Bantal / Gorden / Karpet" },
            { name: "Karpet Biasa", price: "Rp 15.000", ket: "Per meter", eta: "5 hari", opt: "Satuan — Boneka / Bantal / Gorden / Karpet" },
        ],
        extras: [],
    },
    sepatu: {
        rows: [
            { name: "Fast Clean", price: "Rp 30.000", ket: "Per pasang", eta: "Reguler 3 hari · Express 1 hari", opt: "Sepatu — Fast Clean" },
            { name: "Deep Cleaning Reguler", price: "Rp 50.000", ket: "Per pasang", eta: "3 hari", opt: "Sepatu — Deep Cleaning" },
            { name: "Deep Cleaning Express", price: "Rp 100.000", ket: "Per pasang", eta: "1 hari", opt: "Sepatu — Deep Cleaning" },
            { name: "Sandal", price: "Rp 25.000", ket: "Per pasang", eta: "3 hari", opt: "Sepatu — Sandal" },
        ],
        extras: [
            "Leather Treatment — Rp 15.000",
            "Suede Treatment — Rp 50.000",
            "Whitening — Rp 50.000",
            "Unyellowing — Rp 50.000",
            "Re-Glue — Rp 50.000",
            "Repaint Canvas/Suede Low — Rp 80.000",
            "Repaint Canvas/Suede High — Rp 100.000",
            "Repaint Midsole — Rp 75.000",
            "Reppealent — Rp 20.000",
        ],
    },
};

const TABS = [
    { id: "kiloan", label: "Kiloan (per kg)" },
    { id: "satuan", label: "Satuan (per pcs)" },
    { id: "sepatu", label: "Sepatu & Sandal" },
];

function order() {
    scrollToId("form");
}

export default function Pricing() {
    const [tab, setTab] = useState("kiloan");
    const active = DATA[tab];

    return (
        <section id="harga" className="relative bg-brand-mist/50 py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-6">
                <Reveal>
                    <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                        <div>
                            <Eyebrow>Daftar Harga</Eyebrow>
                            <h2 className="mt-5 max-w-xl font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
                                Harga jujur, hasil memuaskan.
                            </h2>
                        </div>
                        <div className="flex flex-col items-start gap-3 lg:items-end">
                            <div className="flex flex-wrap items-center gap-2">
                                <span className="inline-flex items-center gap-1.5 rounded-full bg-cherry px-4 py-1.5 text-xs font-bold text-white">
                                    <Percent size={13} strokeWidth={3} />
                                    Member Silver −5%
                                </span>
                                <span className="inline-flex items-center gap-1.5 rounded-full bg-cherry px-4 py-1.5 text-xs font-bold text-white">
                                    <Percent size={13} strokeWidth={3} />
                                    Member Gold −10%
                                </span>
                                <span className="inline-flex items-center gap-1.5 rounded-full bg-cherry px-4 py-1.5 text-xs font-bold text-white">
                                    <Percent size={13} strokeWidth={3} />
                                    Member Platinum −20%
                                </span>
                            </div>
                            <p className="max-w-sm text-sm leading-relaxed text-ink/50 lg:text-right">
                                Harga dapat berubah sewaktu-waktu — konfirmasi
                                harga terbaru lewat WhatsApp kami.
                            </p>
                        </div>
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <div
                        data-testid="pricing-tabs"
                        className="mt-10 inline-flex flex-wrap gap-1.5 rounded-full border border-border bg-white p-1.5 shadow-brand"
                    >
                        {TABS.map((t) => (
                            <button
                                key={t.id}
                                data-testid={`pricing-tab-${t.id}`}
                                onClick={() => setTab(t.id)}
                                className={`rounded-full px-5 py-2.5 text-sm font-bold transition-all duration-200 ${
                                    tab === t.id
                                        ? "bg-brand text-white shadow-brand"
                                        : "text-ink/60 hover:bg-brand-mist hover:text-brand"
                                }`}
                            >
                                {t.label}
                            </button>
                        ))}
                    </div>
                </Reveal>

                <motion.div
                    key={tab}
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-8"
                >
                    <div className="overflow-hidden rounded-3xl border border-border bg-white shadow-brand">
                        <div className="overflow-x-auto" data-testid={`pricing-table-${tab}`}>
                            <Table className="min-w-[680px]">
                                <TableHeader>
                                    <TableRow className="bg-brand-mist/60 hover:bg-brand-mist/60">
                                        <TableHead className="font-bold text-ink/60">Layanan</TableHead>
                                        <TableHead className="font-bold text-ink/60">Harga</TableHead>
                                        <TableHead className="font-bold text-ink/60">Ketentuan</TableHead>
                                        <TableHead className="font-bold text-ink/60">Estimasi</TableHead>
                                        <TableHead className="font-bold text-ink/60" />
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {active.rows.map((row) => (
                                        <TableRow
                                            key={row.name}
                                            data-testid={`pricing-row-${slug(row.name)}`}
                                            className="transition-colors hover:bg-brand-mist/40"
                                        >
                                            <TableCell className="font-semibold text-ink">
                                                {row.name}
                                            </TableCell>
                                            <TableCell className="whitespace-nowrap font-display text-lg font-extrabold text-brand">
                                                {row.price}
                                            </TableCell>
                                            <TableCell className="whitespace-nowrap text-sm text-ink/50">
                                                {row.ket}
                                            </TableCell>
                                            <TableCell className="whitespace-nowrap text-sm text-ink/50">
                                                {row.eta}
                                            </TableCell>
                                            <TableCell className="text-right">
                                                <button
                                                    data-testid={`pricing-cta-${slug(row.opt)}`}
                                                    onClick={() => order(row.opt)}
                                                    className="group inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-brand/30 px-4 py-2 text-xs font-bold text-brand transition-all duration-200 hover:bg-brand hover:text-white"
                                                >
                                                    Pesan
                                                    <ArrowRight
                                                        size={13}
                                                        className="transition-transform duration-200 group-hover:translate-x-0.5"
                                                    />
                                                </button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>

                        {active.extras.length > 0 && (
                            <div className="border-t border-border bg-[#F9FAFB] px-6 py-5 sm:px-8">
                                <p className="text-xs font-bold uppercase tracking-widest text-ink/40">
                                    Layanan Tambahan
                                </p>
                                <div className="mt-3 flex flex-wrap gap-2">
                                    {active.extras.map((e) => (
                                        <span
                                            key={e}
                                            className="rounded-full bg-white px-3.5 py-1.5 text-xs font-semibold text-ink/60 shadow-sm ring-1 ring-border"
                                        >
                                            {e}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
